import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useRequiredFields from "../../../../../hooks/useRequiredFields";
import FormValidation from "../../../../Common/FormValidation";
import Http from "../../../../Common/Http";

const Edit = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  const [region, setRegion] = useState({});
  const [area, setArea] = useState({});
  const [base, setBase] = useState({});
  const [error, setError] = useState({});
  const { checkRequiredFields } = useRequiredFields();
  const [loading, setLoading] = useState(false);

  // Area Load Region Change Wise
  const areaRegionWise = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    Http.get("/region-wise-area/" + value).then((res) => {
      setArea(res.data);
    });

    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Base Load Region Change Wise
  const baseRegionWise = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    Http.get("/area-wise-base/" + value).then((res) => {
      setBase(res.data);
    });

    setInputs((values) => ({ ...values, [name]: value }));
  };

  // const fetchData = () => {
  //   Http.get("/route/" + id + "/edit").then((res) => {
  //     setInputs({
  //       work_place_region_id: res.data.work_place_region_id,
  //       work_place_area_id: res.data.work_place_area_id,
  //       work_place_base_id: res.data.work_place_base_id,
  //       name: res.data.name,
  //       started_from: res.data.started_from,
  //       status: res.data.status,
  //       remarks: res.data.remarks,
  //     });
  //     // Deafault Area Data Load
  //     Http.get("/region-wise-area/" + res.data.work_place_region_id).then(
  //       (res) => {
  //         setArea(res.data);
  //       }
  //     );
  //     // Deafault Base Data Load
  //     Http.get("/area-wise-base/" + res.data.work_place_area_id).then((res) => {
  //       setBase(res.data);
  //     });
  //   });

  //   // Default Region Data Load
  //   Http.get("/region").then((res) => {
  //     setRegion(res.data);
  //   });
  // };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [routeRes, regionRes] = await Promise.all([Http.get("/route/" + id + "/edit"), Http.get("/region")]);

      setInputs({
        work_place_region_id: routeRes.data.work_place_region_id,
        work_place_area_id: routeRes.data.work_place_area_id,
        work_place_base_id: routeRes.data.work_place_base_id,
        name: routeRes.data.name,
        started_from: routeRes.data.started_from,
        status: routeRes.data.status,
        remarks: routeRes.data.remarks,
      });

      // Deafault Area Data Load
      Http.get("/region-wise-area/" + routeRes.data.work_place_region_id).then((res) => {
        setArea(res.data);
      });

      // Deafault Base Data Load
      Http.get("/area-wise-base/" + routeRes.data.work_place_area_id).then((res) => {
        setBase(res.data);
      });

      setRegion(regionRes.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    if (checkRequiredFields()) {
      Http.put("/route/" + id, inputs)
        .then((res) => {
          navigate("/route", {
            state: { message: res.data.message, type: res.data.type },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    }
  };

  return (
    <div>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Route</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            {error && Object.keys(error).length > 0 && (
              <div className="row">
                <div className="col-lg">
                  <FormValidation error={error} />
                </div>
              </div>
            )}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label className="font-weight-bold" htmlFor="">
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Input Name"
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label className="font-weight-bold" htmlFor="">
                      Select Region <i className="fa fa-star required"></i>
                    </label>
                    <select
                      className="form-control"
                      name="work_place_region_id"
                      onChange={areaRegionWise}
                      value={inputs.work_place_region_id}
                      data-required
                    >
                      {Array.from(region).map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg">
                    <label className="font-weight-bold" htmlFor="">
                      Select Area <i className="fa fa-star required"></i>
                    </label>
                    <select
                      className="form-control"
                      name="work_place_area_id"
                      onChange={baseRegionWise}
                      value={inputs.work_place_area_id}
                      data-required
                    >
                      {Array.from(area).map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg">
                    <label className="font-weight-bold" htmlFor="">
                      Select Base <i className="fa fa-star required"></i>
                    </label>
                    <select
                      className="form-control"
                      name="work_place_base_id"
                      onChange={handleChange}
                      value={inputs.work_place_base_id}
                      data-required
                    >
                      {Array.from(base).map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg">
                    <label className="font-weight-bold" htmlFor="">
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="started_from"
                      value={inputs.started_from || ""}
                      onChange={handleChange}
                      data-required
                    />
                  </div>

                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label className="font-weight-bold" htmlFor="">
                      Status
                    </label>
                    <select className="form-control" name="status" onChange={handleChange}>
                      <option value="active" selected={inputs.status === "active" ? true : false}>
                        Active
                      </option>
                      <option value="inactive" selected={inputs.status === "inactive" ? true : false}>
                        inactive
                      </option>
                    </select>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label className="font-weight-bold" htmlFor="">
                      Remarks
                    </label>
                    <textarea
                      className="form-control"
                      name="remarks"
                      onChange={handleChange}
                      placeholder="Remarks"
                      value={inputs.remarks || ""}
                    ></textarea>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button className="btn btn-primary btn-block mg-b-10" onClick={formSubmit}>
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Edit;
